export const createPairs = (singleInteger: number, listOfIntegers: number[]): number[][] => {
  return listOfIntegers.map((int) => [singleInteger, int])
}
